import { FormikErrors } from 'formik';
import { pluralize } from '~/utils';

import { MAX_TAGS, MIN_TAGS } from './ContentStrengths.constants';
import { ContentStrengthsValues } from './ContentStrengths.types';

export const ContentStrengthsValidate = (fields: ContentStrengthsValues) => {
  let errors: FormikErrors<ContentStrengthsValues> = {};
  if (fields.contentStrengths.length < MIN_TAGS) {
    errors.contentStrengths = `Min. ${MIN_TAGS} ${pluralize(
      'tag',
      'tags',
      MIN_TAGS,
    )}`;
  }
  if (fields.contentStrengths.length > MAX_TAGS) {
    errors.contentStrengths = `Max. ${MAX_TAGS} ${pluralize(
      'tag',
      'tags',
      MAX_TAGS,
    )}`;
  }
  return errors;
};
